export enum JobType {
    Backup = 0,
    Move = 1,
    Remove = 2,
    Copy = 3,
    Retrieve = 4,
    ChangeDataRetrievalAvailabilityPeriod = 5,
    RemoveDataRetrieval = 6
}
